/* eslint-disable react/prop-types */
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import FileUpload from '@mui/icons-material/FileUpload'
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import ComboBox from 'Components/ComboBox'
import { React, useEffect, useState } from 'react'
import { find, isEmpty } from 'lodash'
import { useForm } from 'react-hook-form'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import { currentDate } from '../../../utils/helpers'
import { useNavigate } from 'react-router-dom'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import { setSiteUser } from 'reduxLib/slices/userSlice'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// LAP-XXX — Social Dashboard v2 : champs Importance + Type de relation.
import RelationshipFields from '../_shared/RelationshipFields'
import useUrlAction from '../../../utils/urlAction'

export default function CreateOperationForm({ setOperations, fetchOperations }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const Titres = [
    { id: 1, label: 'Mme' },
    { id: 2, label: 'Mr' },
    { id: 3, label: 'Mlle' },
    { id: 4, label: 'Dr' },
    { id: 5, label: 'ST' },
  ]

  const [open, setOpen] = useState(false)
  const [openGroup, setOpenGroup] = useState(false)
  // LAP-XXX — Social Dashboard v2.
  const [rating, setRating] = useState(0)
  const [relationshipType, setRelationshipType] = useState(null)
  const [categories, setCategories] = useState([])
  const [Souscategories, setSousCategories] = useState([])
  const [selectedSousCategories, setSelectedSousCategories] = useState([])
  const [sousCategory, setSousCategory] = useState('')
  const [Groupes, setGroupes] = useState([])
  const [getPays, setPays] = useState([])
  const [file, setFile] = useState(null)
  const [getInformation, setInformation] = useState(false)
  const [getSocialMedia, setSocialMedia] = useState(false)
  const [getAddress, setAddress] = useState(false)
  let w_contact = localStorage.getItem('w-contact')

  useEffect(() => {
    if (w_contact) {
      setOpen(true)
    }
  }, [])

  // Ajout rapide (shell mobile) : /MesContacts?action=new-contact ouvre
  // directement le formulaire de création de contact.
  useUrlAction('new-contact', () => setOpen(true))
  // useEffect(() => {
  //   if (!isEmpty(Souscategories)) {
  //     const selectedCat = find(Souscategories, ['category', sousCategory])
  //     setSelectedSousCategories([selectedCat])
  //   }
  // }, [sousCategory])

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Date: currentDate(),
      Portable: '',
      Email: '',
      Categorie: '',
      SousCategorie: '',
      Job: '',
      Société: '',
      Téléphone_pro: '',
      Email_pro: '',
      Instagram: '',
      Facebook: '',
      Linkedin: '',
      WebPage: '',
      Pays: '',
      Ville: '',
      Groupes: '',
      image: '',
    },
  })

  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}`, id: v.id })
      })
      setPays([...filterPays])
    }
  }
  const fetchCategories = async () => {
    const url = '/api/Social/get-categories/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterCategories = []
      data.Categorie.forEach((v) => {
        filterCategories.push({ label: `${v.Categorie}`, id: v.id })
      })
      const filterSousCategories = []
      data.SousCategorie.forEach((v) => {
        filterSousCategories.push({
          label: `${v.SousCategorie}`,
          id: v.id,
          category: v.Categorie,
        })
      })
      setSousCategories(filterSousCategories)
      setCategories(filterCategories)
    }
  }
  const fetchGroupes = async () => {
    const url = '/api/Social/get-groups/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterGroupes = []
      data.forEach((v) => {
        filterGroupes.push(v.Name)
      })
      setGroupes(filterGroupes)
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    reset()
    fetchCategories()
    fetchGroupes()
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = (data) => {
    let url = '/api/Social/create-contact/'

    let formData = new FormData()

    if (data.Titre !== null) {
      formData.append('Titre', data.Titre.id)
    }
    if (data.Nom !== null) {
      formData.append('Nom', data.Nom)
    }
    if (data.Prenom !== null) {
      formData.append('Prenom', data.Prenom)
    }
    if (data.Anniversaire !== null) {
      formData.append('Anniversaire', data.Anniversaire)
    }
    if (data.Portable !== null) {
      formData.append('Portable', data.Portable)
    }
    if (data.Email !== null) {
      formData.append('Email', data.Email)
    }
    if (data.Categorie !== null) {
      formData.append('Categorie', data.SousCategorie?.id || data.Categorie?.id)
    }
    if (data.SousCategorie !== null) {
      formData.append('SousCategorie', data.SousCategorie?.label)
    }
    if (data.Job !== null) {
      formData.append('Job', data.Job)
    }
    if (data.Société !== null) {
      formData.append('Société', data.Société)
    }
    if (data.Téléphone_pro !== null) {
      formData.append('Téléphone pro', data.Téléphone_pro)
    }
    if (data.Email_pro !== null) {
      formData.append('Email pro', data.Email_pro)
    }
    if (data.Instagram !== null) {
      formData.append('Instagram', data.Instagram)
    }
    if (data.Facebook !== null) {
      formData.append('Facebook', data.Facebook)
    }
    if (data.Linkedin !== null) {
      formData.append('Linkedin', data.Linkedin)
    }
    if (data.WebPageWebPage !== null) {
      formData.append('WebPage', data.WebPage)
    }
    if (data.Pays !== null) {
      formData.append('Pays', data.Pays?.id)
    }
    if (data.Ville !== null) {
      formData.append('Ville', data.Ville)
    }
    if (data.Groupes) {
      formData.append('Groupes', data.Groupes)
    }
    // LAP-XXX — Social Dashboard v2 : rating + relationship_type.
    formData.append('rating', String(rating ?? 0))
    if (relationshipType) {
      formData.append('relationship_type', relationshipType)
    }
    if (file) {
      formData.append('image', file)
    }

    let response = makePostRequest(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
      .then(async (res) => {
        if (res.status === 200) {
          fetchOperations()
          // setOperations((operations) => ({
          //   ...operations,
          //   results: [...operations.results, response.data],
          //   count: operations.count + 1,
          // }))
          if (w_contact) {
            localStorage.setItem('contact-added', true)
            localStorage.removeItem('w-contact')
            
            // Refresh user data from backend to get updated wizard progress
            try {
              const userResponse = await makeGetRequest('/api/user/user/', {}, true)
              if (userResponse.status === 200 && userResponse.data) {
                // Ensure first_login_completed is not set to true if there are still incomplete steps
                const updatedUser = { ...userResponse.data }
                const user_wizard = updatedUser.user_wizard || []
                const hasIncompleteSteps = user_wizard.some(step => !step.completed && !step.skip)
                
                // If there are incomplete steps, ensure first_login_completed is false
                if (hasIncompleteSteps && updatedUser.first_login_completed === true) {
                  updatedUser.first_login_completed = false
                }
                
                dispatch(setSiteUser(updatedUser))
                
                // Find next incomplete step after current step
                const sorted = [...user_wizard].sort((a, b) => {
                  const progA = a.progression || a.appmessage || 0
                  const progB = b.progression || b.appmessage || 0
                  return progA - progB
                })
                
                // Find current step position, then next incomplete step after it
                let foundCurrent = false
                let nextStep = null
                for (const ws of sorted) {
                  if (ws.step === w_contact) {
                    foundCurrent = true
                    continue
                  }
                  if (foundCurrent && !ws.completed && !ws.skip) {
                    nextStep = ws
                    break
                  }
                }
                
                // Fallback: if no next step found after current, find first incomplete
                if (!nextStep) {
                  nextStep = sorted.find(ws => !ws.completed && !ws.skip)
                }
                
                // Navigate to home - App.js will show the next step based on updated user_wizard state
                if (nextStep) {
                  navigate('/')
                  return
                }
              }
            } catch (error) {
              console.error('Error refreshing user data:', error)
            }
            
            // If no next step found, navigate to home (wizard complete)
            localStorage.setItem('t_message', '1 contact ajouté à votre cercle.')
            navigate('/')
          }
          handleClose()
        }
      })
      .catch((err) => {
        console.log(err.response.data)
      })
    setOpen(false)
  }

  return (
    <>
      {/* LAP-733 (GE022) */}
      <CustomButton onClick={handleClickOpen}>{t('contacts.btnCreate')}</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open}>
        <DialogTitle sx={{ color: 'black !important' }}>Gérer Contacts</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Titre', j)}
              label="Titre"
              data={Titres}
              name="Titre"
              required={false}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                size: 'small',
                type: 'text',
                required: true,
              }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
              }}
              name="Prenom"
              label="Prénom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'Date',
                required: false,
              }}
              rules={{ required: false }}
              name="Anniversaire"
              // label='Anniversaire'
              sx={{ width: '98%' }}
              InputLabelProps={{ shrink: true }}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
              }}
              name="Portable"
              label="Portable"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
              }}
              name="Email"
              label="Email"
            />

            {/* LAP-XXX — Social Dashboard v2 : importance + type de relation. */}
            <RelationshipFields
              rating={rating}
              relationshipType={relationshipType}
              onChangeRating={setRating}
              onChangeRelationshipType={setRelationshipType}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Categorie', j)
                // console.log(
                if (getValues('SousCategorie')) {
                  document
                    .getElementsByName('SousCategorie')[0]
                    .getElementsByClassName('MuiAutocomplete-clearIndicator')[0]
                    .click()
                }

                setSelectedSousCategories(Souscategories.filter((e) => e.category === j.label))
              }}
              label="Categorie (legacy)"
              data={categories}
              name="Categorie"
              // onClose={(event) => {
              //   setSousCategory(event.target.innerHTML.split('-')[1])
              // }}
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('SousCategorie', j)}
              label="SousCategorie"
              data={selectedSousCategories}
              name="SousCategorie"
            />
            {/* <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                disabled: true,
              }}
              disabled
              name="f"
              label={
                SouscategoriesID !== null
                  ? Souscategories[ SouscategoriesID ].label.split( '-' )[ 1 ]
                  : 'SousCategorie'
              }
            /> */}
            <Stack mt={2} justifyContent="center" width={'100%'}>
              <Button variant="outlined" component="label">
                <FileUpload /> Charger photo
                <input type="file" hidden onChange={(e) => setFile(e.target.files[0])} />
              </Button>
            </Stack>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setOpenGroup(true)}>
                  Affectation groupe <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={openGroup}
                  onClose={() => setOpenGroup(false)}
                >
                  <DialogTitle>Groupe</DialogTitle>
                  <form>
                    <DialogContent>
                      <FormControl>
                        <RadioGroup
                          onChange={(e) => {
                            setValue('Groupes', e.target.value)
                          }}
                          aria-labelledby="Groupes"
                          defaultValue="female"
                          name="Groupes"
                        >
                          {Groupes.map((v) => {
                            return (
                              <FormControlLabel
                                key={v.index}
                                value={v}
                                control={<Radio />}
                                label={v}
                              />
                            )
                          })}
                        </RadioGroup>
                      </FormControl>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpenGroup(false)}>Valider</Button>
                      <Button onClick={() => setOpenGroup(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setInformation(true)}>
                  Informations professionnelles <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={getInformation}
                  onClose={() => setInformation(false)}
                >
                  <DialogTitle>Informations pro</DialogTitle>
                  <form>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Job"
                        label="Job"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Société"
                        label="Société"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          size: 'small',
                          type: 'text',
                        }}
                        name="Téléphone_pro"
                        label="Téléphone pro"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                        }}
                        name="Email_pro"
                        label="Email pro"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setInformation(false)}>Valider</Button>
                      <Button onClick={() => setInformation(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setSocialMedia(true)}>
                  Réseaux sociaux <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={getSocialMedia}
                  onClose={() => setSocialMedia(false)}
                >
                  <DialogTitle>Réseaux</DialogTitle>
                  <form>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Instagram"
                        label="Instagram"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Facebook"
                        label="Facebook"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          size: 'small',
                          type: 'text',
                        }}
                        name="Linkedin"
                        label="Linkedin"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                        }}
                        name="WebPage"
                        label="Web Page"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setSocialMedia(false)}>Valider</Button>
                      <Button onClick={() => setSocialMedia(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
              <>
                <CustomButton
                  sx={{ color: '#1d78d2' }}
                  onClick={() => {
                    setAddress(true)
                    fetchPays()
                  }}
                >
                  Adresse <ArrowForwardIcon />
                </CustomButton>
                <Dialog fullWidth maxWidth="xs" open={getAddress} onClose={() => setAddress(false)}>
                  <DialogTitle>Adresse</DialogTitle>
                  <form>
                    <DialogContent>
                      <ComboBox
                        handleAutoComplete={(e, j) => setValue('Pays', j)}
                        label="Pays"
                        data={getPays}
                        name="Pays"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Ville"
                        label="Ville"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setAddress(false)}>Valider</Button>
                      <Button onClick={() => setAddress(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
            </div>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_contact) {
                  localStorage.removeItem('w-contact')
                  navigate('/')
                }
              }}
            >
              Annuler
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
